'use client'
import styles from './PageAnnouncement.module.scss'
import SVGAnnouncement from '@/src/components/common/SVG/SVGAnnouncement'
import SVGClose from '@/src/components/common/SVG/SVGClose'
import WysiwygContent from '@/src/components/common/WysiwygContent'
import PageGutter from '@/src/components/common/PageGutter'
import { useState } from 'react'
import usePageLoad from '@/src/hooks/usePageLoad'
import { md5 } from '@/src/helpers/string'

export default function PageAnnouncementClient(_: { announcement: string }) {
  const storageKey = 'ag-announcement-closed'

  const [closed, setClosed] = useState(true)
  usePageLoad(() => {
    setClosed(localStorage.getItem(storageKey) === md5(_.announcement))
  })

  const handleClose = () => {
    localStorage.setItem(storageKey, md5(_.announcement))
    setClosed(true)
  }

  return closed ? null : (
    <div className={styles.container}>
      <PageGutter className={styles.gutterContent}>
        <SVGAnnouncement />
        <WysiwygContent content={_.announcement} className={styles.content} />
        <SVGClose width={10} className={styles.close} onClick={handleClose} />
      </PageGutter>
    </div>
  )
}
